export const ButtonOutline = ['DIALOG', 'PROJECT_ACTION'] as const;
export type ButtonOutlineType = typeof ButtonOutline[number];
